export default "__VITE_ASSET__57957454__"